<template>
  <lazy-div>
    <v-card>
      <v-card-title>
        <div class="headline">Sub Member Details</div>
      </v-card-title>
      <v-card-text v-if="!query">
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs4>
              <v-select :items="salutationList" v-model="subMemberForm.salutation" :label="labels.salutation" item-text="label" item-value="value" data-vv-name="salutation" :data-vv-as="labels.salutation" :error-messages="errors.collect('salutation')" v-validate="'required'" @input="doSalutation"></v-select>
            </v-flex>
            <v-flex xs8>
              <v-text-field v-model="subMemberForm.name" :label="labels.name" :error-messages="errors.collect('name')" data-vv-name="name" :data-vv-as="labels.name" v-validate="'required|max:60'"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-text-field v-model="subMemberForm.nricPassport" :label="labels.nricPassport" :error-messages="errors.collect('nricPassport')" data-vv-name="nricPassport" :data-vv-as="labels.nricPassport" v-validate="'required|max:20'"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <cal-picker :label="labels.dob" v-model="subMemberForm.dob" :error-messages="errors.collect('dob')" data-vv-name="dob" :data-vv-as="labels.dob" v-validate="'required'"></cal-picker>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <v-radio-group v-model="subMemberForm.gender" row :label="labels.gender" :error-messages="errors.collect('gender')" data-vv-name="gender" :data-vv-as="labels.gender" v-validate="'required'">
                <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs6>
              <v-select :items="relationshipList" v-model="subMemberForm.relationship" :label="labels.relationship" item-text="label" item-value="value" data-vv-name="relationship" :data-vv-as="labels.relationship" :error-messages="errors.collect('relationship')" v-validate="'required'"></v-select>
            </v-flex>
          </v-layout>
          <!-- <v-layout row wrap> AR: 28Jul2020 SR5359
            <v-flex xs12>
              <v-checkbox v-model="subMemberForm.isStudent" :label="labels.isStudent" :error-messages="errors.collect('isStudent')" data-vv-name="isStudent" :data-vv-as="labels.isStudent" hide-details></v-checkbox>
            </v-flex>
          </v-layout> -->
          <v-btn color="primary" :loading="submitting" dark class="mb-2" @click="doNewSubMember" v-if="newSubMember">
            Save Sub Member Detail
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-btn color="primary" :loading="submitting" dark class="mb-2" @click="doUpdateSubMember" v-else>
            Update Sub Member Detail
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-container>
      </v-card-text>
      <!-- subMember query  -->
      <v-card-text v-else>
        <v-layout row wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.salutation}}</v-subheader>
            <div class="title">{{subMemberForm.salutation}}</div>
          </v-flex>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.name}}</v-subheader>
            <div class="title">{{subMemberForm.name}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.nricPassport}}</v-subheader>
            <div class="title">{{subMemberForm.nricPassport}}</div>
          </v-flex>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.dob}}</v-subheader>
            <div class="title">{{subMemberForm.dob}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.gender}}</v-subheader>
            <div class="title">{{subMemberForm.gender}}</div>
          </v-flex>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.relationship}}</v-subheader>
            <div class="title">{{subMemberForm.relationship}}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs5>
            <v-subheader class="queryLabel">{{labels.isStudent}}</v-subheader>
            <div class="title">{{subMemberForm.isStudent}}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </lazy-div>
</template>

<script>
import { salutation, gender } from '@/const/underwriting'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        salutation: 'Salutation*',
        name: 'Name as in NRIC/Passport*',
        nricPassport: 'NRIC/Passport*',
        dob: 'Date of Birth*',
        gender: 'Gender*',
        isStudent: 'Are you a full time student?',
        relationship: 'Relationship'
      },
      subMemberForm: {
        salutation: null,
        name: null,
        nricPassport: null,
        dob: null,
        gender: null,
        isStudent: null,
        relationship: null
      },
      relationshipList: null,
      newSubMember: false,
      submitting: false,
      query: false
    }
  },
  created() {
    if (this.$route.name === 'subMemberDetQuery') {
      this.query = true
    } else {
      this.query = false
    }
  },
  mounted() {
    this.getRelationshipList()
    if (this.seq === 'new') {
      this.newSubMember = true
    } else {
      this.newSubMember = false
      this.doFetch()
    }
  },
  methods: {
    async doFetch() {
      const apiURI = this.menu.subMemberGet
      if (apiURI) {
        try {
          const expand = {
            usrId: this.id,
            seq: this.seq
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            const { data } = result.data
            if (data) {
              this.subMemberForm.salutation = data.usrSubMember.salutation
              this.subMemberForm.name = data.usrSubMember.name
              this.subMemberForm.nricPassport = data.usrSubMember.nricPassport
              this.subMemberForm.dob = data.usrSubMember.dob
              this.subMemberForm.gender = data.usrSubMember.gender
              this.subMemberForm.relationship = data.usrSubMember.relationship
              this.subMemberForm.isStudent = data.usrSubMember.isStudent
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doNewSubMember() {
      const result = await this.$validator.validateAll()
      if (result) {
        this.submitting = true
        const apiURI = this.menu.subMemberCreate
        if (apiURI) {
          const expand = {
            usrId: this.id
          }
          this.$http.post(expandURI(apiURI, expand), this.subMemberForm).then(result => {
            const { data } = result
            if (data) {
              this.notify(data)
              const commitData = {
                tabMenu: 0,
                displayReviewTab: false
              }
              this.$store.commit('TABMENU', commitData)
              this.$router.push({ name: 'subMemberList' })
            }
            this.submitting = false
          }).catch(err => {
            this.submitting = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
        }
      } else {
        this.promptFieldCheck()
      }
    },
    async doUpdateSubMember() {
      const result = await this.$validator.validateAll()
      if (result) {
        this.submitting = true
        const apiURI = this.menu.subMemberUpdate
        if (apiURI) {
          const expand = {
            usrId: this.id,
            seq: this.seq
          }
          this.$http.put(expandURI(apiURI, expand), this.subMemberForm).then(result => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doFetch()
            }
            this.submitting = false
          }).catch(err => {
            this.submitting = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
        }
      } else {
        this.promptFieldCheck()
      }
    },
    getRelationshipList() {
      const apiURI = this.menu.relationshipList
      if (apiURI) {
        this.$http.get(apiURI).then(result => {
          const { data } = result.data
          this.relationshipList = data
        })
      }
    },
    doSalutation() {
      if (this.subMemberForm.salutation === 'MR') {
        this.subMemberForm.gender = 'M'
      } else if (this.subMemberForm.salutation === 'MS' || this.subMemberForm.salutation === 'MDM' || this.subMemberForm.salutation === 'MRS') {
        this.subMemberForm.gender = 'F'
      } else {
        if (!this.subMemberForm.gender || this.subMemberForm.gender === null) {
          this.subMemberForm.gender = 'M'
        }
      }
    }
  },
  computed: {
    genderList() {
      let result = []
      Object.keys(gender).forEach(function(key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function(key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    menu() {
      return this.$store.state.adminMember.menu
    }
  },
  props: ['id', 'seq'],
  mixins: [MessageMixin]
}
</script>

<style>
</style>
